import React from "react";
import { useParams, useLocation } from "react-router";

import ActionPageHero from "../../../molecules/ActionPageHero";
import { WidgetCard } from "../../../atoms/Cards/card.widget";

import searchWidgetBanner from "../../../../assets/images/search-widget-banner.png";
import referralWidgetBanner from "../../../../assets/images/referral-widget-banner.png";

const widgets = [
  {
    title: "SSN Search",
    description:
      "The widget embeds the SSN search feature onto your website. It allows you to use our pre-built search component, to create an interactive form that lets your users search for organizations offering the services they need, so you do not have to stress about the API integration.",
    img: searchWidgetBanner,
    link: "search",
    status: "available",
  },
  {
    title: "SSN Refferal",
    description:
      "The widget embeds the SSN referral feature onto your website. It allows you to receive referrals from your website. The user provides their name and email, and gets referred to the service you offer.",
    img: referralWidgetBanner,
    link: "search",
    status: "coming soon",
  },
];

const AllWidgetsPage = () => {
  const location = useLocation();

  return (
    <main className="flex flex-col w-full">
      <ActionPageHero
        className="organization-container"
        title="Widgets"
        description="Embed widgets on your website"
      />
      <section className="organization-container pb-10 flex-grow mt-12">
        <div className="w-5/6 grid grid-cols-2 gap-x-5 gap-y-6">
          {widgets?.map((widget, idx) => (
            <WidgetCard
              key={idx}
              title={widget.title}
              img={widget.img}
              description={widget.description}
              status={widget.status}
              link={`${location.pathname}/${widget.link}`}
            />
          ))}
        </div>
      </section>
    </main>
  );
};

export default AllWidgetsPage;
